<template lang="pug">
.activity
    page(v-if="$apollo.loading")
        empty(:info="true", :big="false")
            .schools__loading
                img(src="/info.svg")
                span Loading...
    page(v-else-if="referralIds && referralIds.length")
        referral-events(:referralIds="referralIds")
    page(v-else)
        empty No events found
</template>

<script>
import ReferralEvents from "@/views/referral/includes/ReferralEvents";
import gql from "graphql-tag";

export default {
	name: "SchoolActivity",
	components: {
		ReferralEvents
	},
	computed: {
		referralIds() {
			if (!this.Referrals || !this.Referrals.length) return "";

			return this.Referrals.map(r => r.id).join(",");
		}
	},
	apollo: {
		Referrals: {
			query: gql`
				query Referrals($school: String) {
					Referrals(school: $school) {
						id
						created_at
					}
				}
			`,
			variables() {
				return {
					school: this.$route.params.school
				};
			},
			fetchPolicy: "cache-and-network"
		}
	}
};
</script>
